import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';

const REWARE_API_BASE = process.env.REWARE_API_BASE || 'http://localhost:8080';

export const TroveLogin = () => {
  const handleGoogleLogin = () => {
    window.location.href = `${REWARE_API_BASE}/auth/google_oauth2?app=partner-dashboard`;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Card sx={{ minWidth: 400, maxWidth: 500 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              Trove Partner Dashboard
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Sign in with your Trove account
            </Typography>
          </Box>

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleGoogleLogin}
            sx={{ py: 1.5 }}
          >
            Sign In with Google
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};
